export enum EChoiceFilter {
	sameTime,
	sameDay,
	samePatient,
	sameIntervenant,
	future,
	current,
	sameActe
}